export const columns = [
  { accessorKey: "paymentType", header: "Type of Payment", flex: 1 },
  { accessorKey: "paymentQuantity", header: "Quantity", flex: 1 },
  {
    accessorKey: "discount",
    header: "Discount Amount",
    flex: 1,
    Cell: ({ row }: any) => {
      const discount = Math.round(
        (row.original.discount || 0) * (row.original.paymentQuantity || 1)
      );
      return discount > 0
        ? `PKR ${discount.toLocaleString(undefined, { maximumFractionDigits: 2 })}`
        : "-";
    },
  },
  {
    accessorKey: "discountTotal",
    header: "Discount Total",
    flex: 1,
    Cell: ({ row }: any) => {
      const quantity = row.original.paymentQuantity || 1;
      const discountPerUnit = row.original.discount || 0;
      const totalDiscount = discountPerUnit * quantity;

      // For terminalType == 4, use discountedCharges (original amount) to calculate total charges
      // Otherwise, use chargesPerUnit or calculate from charges
      let totalCharges = 0;
      if (row.original.discountedCharges !== undefined && row.original.discountedCharges > 0) {
        // Use original charges (discountedCharges) for calculation
        const originalChargesPerUnit = row.original.discountedCharges;
        totalCharges = originalChargesPerUnit * quantity;
      } else {
        // Get charges per unit (use preserved chargesPerUnit or calculate from formatted string)
        const chargesPerUnit =
          row.original.chargesPerUnit !== undefined
            ? row.original.chargesPerUnit
            : typeof row.original.charges === "string"
            ? parseFloat(row.original.charges.replace(/[^0-9.]/g, "")) /
                (row.original.paymentQuantity || 1) || 0
            : (row.original.charges || 0) / (row.original.paymentQuantity || 1);
        totalCharges = chargesPerUnit * quantity;
      }

      // Discount Total = Total Charges - Total Discount (amount after discount)
      const discountTotal = Math.round(totalCharges - totalDiscount);
      const currency = row.original.currency || "PKR";

      return discountPerUnit > 0
        ? `${currency} ${discountTotal.toLocaleString(undefined, { maximumFractionDigits: 0 })}`
        : "-";
    },
  },
  { accessorKey: "charges", header: "Total Charges", flex: 1 },
  {
    accessorKey: "actionButtons",
    header: "Action",
    flex: 1,
    accessorFn: (row: any) => ` ${row.actionButtons || " "}`,
  },
];
